import { createSelector } from '@reduxjs/toolkit';
import selectCurrentAccount from './selectCurrentAccount';
import { DEFAULT_CONNECTION_LIMIT } from '../../../helpers/constants';

export default createSelector(
  selectCurrentAccount,
  (currentAccount) => currentAccount?.maxIntegrationCount ?? DEFAULT_CONNECTION_LIMIT
);
